import React from 'react';

import { i18n } from '../../../../../../shared/helpers/i18n';
import useChangeContentOnHover from '../useChangeContentOnHover';
import styles from './styles.css';

export type RecordingPlace = 'local' | 'cloud';

export function useStopRecordingButtonContent(recordingPlace: RecordingPlace) {
    const {
        isHover: isHovered,
        HoverableContent,
        ...buttonProps
    } = useChangeContentOnHover({
        defaultContent: (
            <div className={styles.description}>
                <div className={styles.title}>{i18n('toolbar', 'recording-in-process')}</div>
                <div className={styles.tip}>{i18n('toolbar', `recording-place-${recordingPlace}`)}</div>
            </div>
        ),
        onHoverContent: (
            <div className={styles.description}>
                <div className={styles.title}>{i18n('toolbar', 'recording-stop')}</div>
            </div>
        ),
    });

    const content = (
        <div className={styles.stopButtonContent}>
            <HoverableContent />
        </div>
    );

    return { isHovered, content, buttonProps };
}
